// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const ARRAY_PROPERTIES: any = {
   fvf: true,
   fvfi: true,
   rf: true
}

class UrlService {
   $location: any
   constructor($location: any) {
      this.applyParams = this.applyParams.bind(this)
      this.applyDocumentPath = this.applyDocumentPath.bind(this)
      this.removeDocumentPath = this.removeDocumentPath.bind(this)
      this.$location = $location
   }
   
   paramsToObject(entries: IterableIterator<[string, string]>) {
      const result: any = {}
      for(const [key, value] of entries) { // each 'entry' is a [key, value] tupple
         result[key] = value
      }
      return result
   }

   urlParamsFromString(stringParams: string){
      const urlParams = new URLSearchParams(stringParams)
      const entries: IterableIterator<[string, string]> = urlParams.entries()
      return this.paramsToObject(entries)
   }

   // initialize

   urlParamsFor(params: any) {
      const urlParams = $.extend({}, params)
      // if (urlParams.pn != null) { delete urlParams.pn }
      for (var k in urlParams) {
         var v = urlParams[k]
         if (!angular.isNumber(v) && (v?.length <= 0) && (typeof(v) !== 'boolean') && (k !== 'q')) {
            delete urlParams[k]
            continue
         }
         if (angular.isArray(v)) {
            var pubDateRangeIdx = _.findIndex(v, (fld: any) => fld.indexOf('PublicationDate') === 0)
            if (pubDateRangeIdx >= 0) {
               var [from, to] = v[pubDateRangeIdx].split(",")[1].split(":").map(function (d: any) {
                  if (d !== "*") {
                     const parsedDate: Date = new Date(Date.parse(d))
                     return parsedDate.toISOString().split('T')[0]
                  } else { return d }
               })
               v[pubDateRangeIdx] = "PublicationDate," + from + ":" + to
            }
            urlParams[k] = v.join('|')
         }
         if (v === true) { urlParams[k] = 't' }
         if (v === false) { urlParams[k] = 'f' }
      }
      return urlParams
   }

   urlParamsStringFor(params: any): String {
      const urlParams = this.urlParamsFor(params)
      const paramKeys = Object.getOwnPropertyNames(urlParams)
      let urlParamsString = ""
      paramKeys.forEach(param => {
         const paramAsString = `${param}=${encodeURIComponent(urlParams[param])}`
         urlParamsString = urlParamsString ? `${urlParamsString}&${paramAsString}` : `${paramAsString}`
      })
      return urlParamsString
   }

   applyParams(params: any) {
      const urlParams = this.urlParamsFor(params)
      return this.$location.search(urlParams)
   }

   applyDocumentPath(id: any)  {
      const urlParams = this.$location.search()
      urlParams.id = id
      this.$location.search(urlParams)
      return this.$location.path('/search/document')
   }

   removeDocumentPath() {
      const urlParams = this.$location.search()
      delete urlParams.id
      this.$location.search(urlParams)
      return this.$location.path('/search')
   }

   toParams(params: any) {
      const appParams: any = {}
      for (var k in params) {
         var v = params[k]         
         if (ARRAY_PROPERTIES[k]) {
            appParams[k] = v.split(/(?! )[|](?! )/) // split by | except if surrounded by spaces (in case the param value has a ' | ' in the text). 
         } else if (v === 't') {
            appParams[k] = true
         } else if (v === 'f') {
            appParams[k] = false
         } else {
            appParams[k] = v
         }
      }

      if (appParams.pn == null) { appParams.pn = 1 }
      return appParams
   }
}

UrlService.$inject = ['$location']

angular.module('summonApp.services')
   .service('urlService', UrlService)
